export const ACTION_LOGIN = 'ACTION_LOGIN';
export const ACTION_LOGIN_ERR = 'ACTION_LOGIN_ERR';
export const ACTION_LOGIN_LOAD = 'ACTION_LOGIN_LOAD';
export const ACTION_LOGOUT = 'ACTION_LOGOUT';
export const ACTION_USERSAVE = 'ACTION_USERSAVE';
//export const ACTION_PAGECHANGE = 'ACTION_PAGECHANGE';
